import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "current"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file || !file.type.startsWith("image/")) return

    const reader = new FileReader()
    reader.addEventListener("load", () => {
      this.previewTarget.innerHTML = `<img src="${reader.result}" class="h-44 w-full rounded-lg object-contain" alt="${file.name}"><p class="mt-2 truncate text-xs font-medium text-slate-600">${file.name}</p>`
      this.previewTarget.hidden = false
      if (this.hasCurrentTarget) this.currentTarget.classList.add("opacity-40")
    })
    reader.readAsDataURL(file)
  }
}
